import { FintalkCloudContextProvider } from 'contexts/FintalkCloud/fintalkCloudContext'
import { PermissionsProvider } from 'contexts/Permissions/permissionsContext'
import { ToastContextProvider } from 'contexts/ToastContext'
import { History } from 'history'
import { FintalkCloud } from 'views/FintalkCloud'
import { AppProvider } from './contexts/App/appContext'
import GlobalStyles from './styles'
import ThemeCustom from './themes/ThemeCustom'
import './utils/i18n'

type Props = {
  history: History<unknown>
}

function App(props: Props) {
  return (
    <>
      <GlobalStyles />

      <AppProvider>
        <PermissionsProvider>
          <ThemeCustom>
            <ToastContextProvider>
              <FintalkCloudContextProvider history={props.history}>
                <FintalkCloud />
              </FintalkCloudContextProvider>
            </ToastContextProvider>
          </ThemeCustom>
        </PermissionsProvider>
      </AppProvider>
    </>
  )
}

export default App
